import React from "react";
import { InfiniteList2, OptionsPanelContainer } from "../../../../../../../common/components";
import Box from "../../../../box/Box";
import styles from "./ProjectList.module.css";

export default function ProjectList({ projectsRequest }) {
	const rowRenderer = (row) => <Box key={row.id} content={row.created} title={row.name} />;
	return (
		<OptionsPanelContainer>
			<InfiniteList2 hasSearch className={styles.container} request={projectsRequest} rowRenderer={rowRenderer} />
		</OptionsPanelContainer>
	);
}
